/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SelfRegistrationRequest = {
    captchaResponseToken: string;
    email: string;
    firstName: string;
    idNumber: string;
    phone: string;
    lastName: string;
    password: string;
    software?: SelfRegistrationRequest.software;
    softwareName?: string;
    newsletter: boolean;
    partnerCode?: string;
};

export namespace SelfRegistrationRequest {
    export enum software {
        POHODA = "POHODA",
        POHODA_SQL = "POHODA_SQL",
        FLEXIBEE = "FLEXIBEE",
        MONEYS3 = "MONEYS3",
        ISDOC = "ISDOC",
        OTHER = "OTHER",
    }
}
